// extracted by mini-css-extract-plugin
module.exports = {"main":"main-25hUl","primary":"primary-3bFLo","active":"active-1alTO"};